import React from 'react';
import { List } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { BASE_LIST_SX, NAV_ICON_MAP } from './constants';
import NavListIcon from './NavListIcon';
import FortressLogoListItem from './FortressLogoListItem';

const NavIconList = ({
  drawerWidth,
  showNavText,
  navOptionsArray = [],
  flags,
}) => {
  return (
    <List
      sx={{
        ...BASE_LIST_SX(flags),
        right: 0,
        width: drawerWidth.closed,
        opacity: showNavText ? 0 : 1,
      }}
    >
      <FortressLogoListItem />

      {navOptionsArray.map((navOption) => {
        return (
          <NavListIcon
            key={navOption.value}
            icon={NAV_ICON_MAP[navOption.value]}
            notification={navOption.notification}
            selected={navOption.selected}
            value={navOption.value}
          />
        );
      })}
    </List>
  );
};

export default NavIconList;
